'use client';

import React, { Component } from 'react';
import './style.sass';

import GensNumbers from '../reusable-components/layouts-components__gens/gens-numbers';
import Task from '../reusable-components/layouts-components__gens/task';
import PortfolioGallery from '../reusable-components/layouts-components__gens/portfolio-gallery';
import Complex from '../reusable-components/layouts-components__gens/complex';
import Process from '../reusable-components/layouts-components__gens/process';
import Results from '../reusable-components/layouts-components__gens/results';
import Numbers from '../reusable-components/layouts-components__gens/ciphers';
import Team from '../reusable-components/layouts-components__gens/team';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';

import OfferButton from '../../../../../shared/sections/OfferButton';
import ScrollAnimation from '../../../../../core/ScrollAnimation';

const gensMainTitle = {
    titleMainText: `Создание ИТ-системы главного технологического акселератора страны`,
    titleAnimation: '/images/pic/preview/generation.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#009bcc',
            nameText: 'ОАО &laquo;Российская венчурная компания&raquo;',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#009bcc',
            nameText: 'Инновации',
        },
        {
            modeText: 'Услуги',
            colorMode: '#009bcc',
            nameText: 'Редизайн, разработка, поддержка',
        },
        {
            modeText: 'Технологии',
            colorMode: '#009bcc',
            nameText: 'Nodejs, Socket.io, React, Redux, Webpack, Sass, Bitrix, PHP',
        },
    ],
};

class Gens extends Component {
    render() {
        const casePathname = '/cases/development/gens';
        const adjacentCase = getAdjacentCase(casePathname);

        return (
            <section className="gens">
                <MainTitle MainTitle={gensMainTitle} />

                <GensNumbers />

                <Task />

                <PortfolioGallery />

                <Complex />

                <Process />

                <Results />

                <Numbers />

                <Team />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                {adjacentCase && (
                    <NextProject
                        NextProject={{
                            nextProjectTitle: adjacentCase.case.title,
                            nextProjectImg: adjacentCase.case.image,
                            nextProjectLink: adjacentCase.case.router,
                            nextProjectText: adjacentCase.case.description,
                            nextProjectLabel: adjacentCase.label,
                        }}
                    />
                )}
            </section>
        );
    }
}

export default Gens;
